import { observer } from 'mobx-react-lite';
import { use } from 'react';
import { classes } from '@/next-utils/css-utils/scss-utils';
import type { VoidCallback } from '@/type-utils';
import type { SearchBoxVM } from '@/react/view-models/SearchBoxVM';
import { Link } from '@/react/components/core-ui/Link';

import S from './styles.base.module.scss';
import ABSuggestedTerms from '../ABSuggestedTerms';

interface ISuggestedSearchTermsProps {
  /** The title to be displayed above the suggested search terms. */
  title: string;

  /** An optional className to be applied to the title element. */
  titleClassName?: string;

  /**
   * The `SearchBoxVM` instance to be used.
   */
  vm: SearchBoxVM;

  /**
   * The function to be called when the user navigates to a new page.
   */
  onNavigate?: VoidCallback;
}

/**
 * A component to display the `Suggested Search Terms` section upon search.
 */
export const SuggestedSearchTerms = observer(function SuggestedSearchTerms({
  vm,
  onNavigate,
  title,
  titleClassName
}: ISuggestedSearchTermsProps) {
  const searchTermsSuggestions =
    vm.searchTermsSuggestions instanceof Promise
      ? use(vm.searchTermsSuggestions)
      : vm.searchTermsSuggestions;
  return (
    <>
      <h3 className={classes(S.title, titleClassName)}>{title}</h3>
      <div className={S.termsGrid}>
        <ABSuggestedTerms
          vm={vm}
          termClassName={S.term}
          onNavigate={onNavigate}
        />
        {searchTermsSuggestions.map(({ term, highlightPortion }) => (
          <Link
            key={highlightPortion}
            className={S.term}
            href={vm.encodeSearchResultsPageNavigationUrl(term)}
            onClick={onNavigate}
            variant="text"
          >
            {term}
          </Link>
        ))}
      </div>
    </>
  );
});
